import { Center, Spinner } from "@chakra-ui/react";

import FeaturedCard from "./FeaturedCard";
import { Songcard as SCType } from "@/types";
import { apiUrl } from "@/constants";
import { useQuery } from "@tanstack/react-query";

export default function ClientSongcard({ uuid }: { uuid: string }) {
  const getCard = async () => {
    const res = await fetch(`${apiUrl}/ninja/cards/${uuid}`);
    const data: SCType = await res.json();
    return data;
  };

  const {
    data: card,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["card", uuid],
    queryFn: getCard,
    enabled: !!uuid,
  });

  if (isLoading || !card)
    return (
      <Center>
        <Spinner />
      </Center>
    );
  if (isError) return <div>Error loading card.</div>;

  return (
    <div style={{ marginBottom: 30 }}>
      <FeaturedCard embed={false} card={card} />
    </div>
  );
}
